import React, { useState, useContext, useEffect } from "react";
import ButtonPrimary from "../../components/buttons/ButtonPrimary";
import Timer from "../../components/timer/Timer";
import Leaderboard from "../../components/common/Leaderboard";
import { ConnectionStatusContext } from "../../provider/ConnectionStatusProvider";
import {
  doc,
  getDoc,
  onSnapshot,
  arrayUnion,
  updateDoc,
  setDoc,
} from "firebase/firestore";

import { db } from "../../firebaseConfig";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Ruins } from "./Ruins";
import { TopTen } from "./dataTopTen";
import TotalValue from "./TotalValue";

interface ObjectWithStackedAt {
  twitterLink: string;
  disableRichThumbnailGeneration: boolean;
  inscription_name: string;
  ownerCount: number;
  inscriptionIcon: string;
  labels: string[];
  imageURI: string;
  supply: number;
  chain: string;
  discordLink: string;
  overrideContentType: string;
  enableCollectionOffer: boolean;
  symbol: string;
  stackedAt: {
    seconds: number;
    nanoseconds: number;
  };
  createdAt: string;
  websiteLink: string;
  name: string;
  description: string;
}

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const connectionStatus = useContext(ConnectionStatusContext);
  const [data, setData] = useState<any>(null);
  const [user, setUser] = useState<any>(null);
  const [totalStalked, setTotalStalked] = useState<any>(null);
  const [myStakes, setMyStakes] = useState<any>(null);
  const [priceData, setPriceData] = useState<any>([]);

  const [totalValue, setTotalValue] = useState<number>(0);
  const [totalValueRuin, setTotalValueRuin] = useState<number>(0);

  const getData = (
    collectionName: string,
    id: string,
    callback: (data: any | undefined) => void
  ) => {
    const docRef = doc(db, collectionName, id);

    const unsubscribe = onSnapshot(
      docRef,
      (docSnap) => {
        if (docSnap.exists()) {
          callback(docSnap.data() as any);
        } else {
          console.log("No such document!");
          callback(undefined);
        }
      },
      (error) => {
        console.error("Error getting real-time updates: ", error);
        callback(undefined);
      }
    );

    return unsubscribe;
  };

  const addDocument = async (id: string, data: any) => {
    try {
      const submitData = { ...data, stackedAt: new Date() };
      const docRef = doc(db, "stalks", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, {
          stalkedItems: arrayUnion(submitData),
        });
        console.log("Document updated with new data in array.");
      } else {
        await setDoc(docRef, {
          stalkedItems: [submitData],
        });
        console.log("Document created and new data added to array.");
      }
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  const handleStakeUnstakeCollection = (
    index: number,
    collection: any,
    stalkedItem: any
  ) => {
    if (
      myStakes?.stalkedItems?.find(
        (v: any) => v.inscription_name === collection?.inscription_name
      )
    ) {
      if (window.confirm("Are you sure you want to unstake?")) {
        console.log("collectionTo", collection);
        const value = calculateValueFromTimestamp(stalkedItem.stackedAt);
        let address =
          connectionStatus?.type === "xverse" ? user?.address : user;
        removeItemFromStalkedItems(
          address,
          collection?.inscription_name,
          value
        );
      }
    } else {
      let address = connectionStatus?.type === "xverse" ? user?.address : user;
      addDocument(address, collection);
    }
  };
  const removeItemFromStalkedItems = async (
    documentId: string,
    inscription_name: string,
    valueAdded: any
  ): Promise<void> => {
    try {
      // Create a reference to the document
      const docRef = doc(db, "stalks", documentId);

      // Fetch the document snapshot
      const docSnap: any = await getDoc(docRef);
      if (!docSnap.exists()) {
        throw new Error(`Document with id ${documentId} does not exist.`);
      }

      // Extract the stalkedItems array and Value from the document data
      let { stalkedItems, Value } = docSnap.data() || {
        stalkedItems: [],
        Value: 0,
      };

      // Find the index of the item to remove based on inscription_name
      const indexToRemove = stalkedItems.findIndex(
        (item: any) => item.inscription_name === inscription_name
      );
      if (indexToRemove === -1) {
        throw new Error(
          `Item with inscription_name ${inscription_name} not found.`
        );
      }

      // Remove the item from the array
      stalkedItems.splice(indexToRemove, 1);

      // Update the Value variable or add it with a value of 20
      if (typeof docSnap.data()?.Value === "number") {
        Value = docSnap.data()!.Value! + valueAdded;
      } else {
        Value = valueAdded;
      }

      // Update the document with the modified stalkedItems array and Value
      await updateDoc(docRef, { stalkedItems, Value });

      console.log(
        `Item with inscription_name ${inscription_name} removed successfully from document ${documentId}.`
      );
    } catch (error: any) {
      console.error("Error removing item:", error.message);
    }
  };

  const convertTimestamp = (timestamp: any): string => {
    const date = timestamp.toDate();

    return date.toString(); // This converts to the desired format
  };

  function calculateSumOfValues(objects: ObjectWithStackedAt[]): number {
    const now: Date = new Date(); // Current date and time
    let sumOfValues: number = 0;

    if (objects) {
      objects.forEach((obj) => {
        const stackedAt: Date = new Date(obj.stackedAt.seconds * 1000); // Convert seconds to milliseconds
        const hoursPassed: number = Math.floor(
          (now.getTime() - stackedAt.getTime()) / (1000 * 60 * 60)
        ); // Calculate hours passed

        // Calculate value based on hours passed (20 units per hour)
        const value: number = hoursPassed * 20;
        sumOfValues += value; // Add value to the sum
      });
    }
    // Calculate sum of values based on hours passed

    return sumOfValues;
  }

  const calculateValueFromTimestamp = (timestamp: any): number => {
    console.log("timeStamp", timestamp);
    // Get the current time in seconds since epoch
    const currentTimeSeconds = Math.floor(Date.now() / 1000);

    // Calculate the difference in seconds between current time and provided timestamp
    const timestampSeconds = timestamp.seconds;
    const differenceSeconds = currentTimeSeconds - timestampSeconds;

    // Calculate the difference in hours
    const differenceHours = Math.floor(differenceSeconds / 3600);

    // Calculate the value as a multiple of 20 for each hour passed
    const value = differenceHours * 20;

    return value;
  };

  function filterArray(
    firstArray: any,
    secondArray: any,
    firstKey: any,
    secondKey: any
  ) {
    // Create a set of matching values from the second array
    const secondSet = new Set(secondArray.map((item: any) => item[secondKey]));

    // Filter the first array based on the matching values
    const filteredFirstArray = firstArray.filter((item: any) =>
      secondSet.has(item[firstKey])
    );

    return filteredFirstArray;
  }

  useEffect(() => {
    console.log("connectionStatusCheck", connectionStatus);
    if (connectionStatus && connectionStatus.isConnected === true) {
      if (connectionStatus?.type === "xverse") {
        let acc = connectionStatus?.accounts.find(
          (v) => v.purpose === "ordinals"
        );
        setUser(acc);
        axios

          .get(`https://softstake-backend.vercel.app/ordinals/${acc?.address}`)
          .then((res) => {
            let filtered = filterArray(
              res?.data?.data,
              TopTen,
              "slug",
              "collectionSymbol"
            );
            console.log("res-stalks", res?.data, filtered);
            setData(filtered);
          })
          .catch((err) => console.log("error", err));
      } else {
        let acc = connectionStatus?.accounts;
        setUser(acc);
        axios
          .get(`https://softstake-backend.vercel.app/ordinals/${acc}`)
          .then((res) => {
            let filtered = filterArray(
              res?.data?.data,
              TopTen,
              "slug",
              "collectionSymbol"
            );
            console.log("res-stalks", res?.data, filtered);

            setData(filtered);
          })
          .catch((err) => console.log("error", err));
      }
    }
  }, [connectionStatus, connectionStatus?.isConnected]);
  const isLoggedIn = () => {
    const localStorageItem: any = localStorage.getItem("auth-item");
    if (localStorageItem) {
      const item = JSON.parse(localStorageItem);
      connectionStatus?.setAccounts(item?.accounts);
      connectionStatus?.setBalance(item?.balance);
      connectionStatus?.setType(item?.type);
      connectionStatus?.setLoading(false);
    } else {
      connectionStatus?.setLoading(false);
    }

    // console.log("localStorageItem", JSON.parse(localStorageItem));
  };

  useEffect(() => {
    isLoggedIn();
    axios

      .get(
        `https://api.allorigins.win/raw?url=${encodeURIComponent(
          "https://api-mainnet.magiceden.dev/collection_stats/search/bitcoin?window=1d&sort=volume&direction=desc&offset=0&limit=100"
        )}`
        // `https://api-mainnet.magiceden.dev/collection_stats/search/bitcoin?window=1d&sort=volume&direction=desc&offset=0&limit=100`
      )

      .then((res) => {
        setPriceData(res?.data);

        // let filtered = res?.data?.filter(
        //   (v: any) => v?.collectionSymbol === "darkman"
        // );
        // console.log("darkman", filtered);
      })
      .catch((err) => console.log("err", err));
  }, []);
  useEffect(() => {
    console.log("useEffect", connectionStatus);
    if (
      connectionStatus &&
      connectionStatus?.loading === false &&
      connectionStatus.isConnected !== true
    ) {
      navigate("/");
    }
  }, [
    connectionStatus,
    connectionStatus?.isConnected,
    connectionStatus?.loading,
  ]);

  useEffect(() => {
    if (user) {
      let address = connectionStatus?.type === "xverse" ? user?.address : user;
      const unsubscribe = getData("stalks", address, (newData) => {
        console.log("newData", newData);

        const totalValue = newData?.Value
          ? calculateSumOfValues(newData?.stalkedItems) + newData?.Value
          : calculateSumOfValues(newData?.stalkedItems);
        setTotalValue(totalValue);
        setMyStakes(newData);
        // setTotalStalked(newData?.stalkedItems.length);
      });

      // Cleanup subscription on unmount
      return () => unsubscribe();
    }
  }, [user]);

  const AddtoDb = async (data: any, id: string) => {
    try {
      const docRef = doc(db, "leaderboard", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, data);
        console.log("Document updated with new data in array.");
      } else {
        await setDoc(docRef, data);
        console.log("Document created and new data added to array.");
      }
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  useEffect(() => {
    if (myStakes !== null && user) {
      let address = connectionStatus?.type === "xverse" ? user?.address : user;
      const submitData = {
        id: address,
        totalValue: totalValue + totalValueRuin,
      };
      AddtoDb(submitData, address);
    }
  }, [myStakes, totalValue, user, totalValueRuin]);

  console.log("priceData", priceData);

  return (
    <main className="py-10">
      <div className="container mx-auto px-4">
        <figure className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 mb-10">
          <div className="flex-1">
            <div className="h-full bg-gradient-to-r from-body to-gray-800 border-2 border-primary rounded-lg shadow-lg p-6 relative">
              <div className="relative z-10 flex items-center gap-6">
                <div>
                  <h6 className="mb-1 font-semibold text-color">
                    Amount Earned
                  </h6>
                  <h2 className="text-white font-bold text-3xl">
                    {totalValue + totalValueRuin} Points
                  </h2>
                </div>
              </div>
              <img
                className="absolute bottom-0 right-0 h-28 w-28 opacity-20"
                src="/assets/images/icon-2.png"
                alt="..."
              />
            </div>
          </div>

          <TotalValue />
          <div className="flex-1">
            <div className="h-full bg-gradient-to-r from-body to-gray-800 border-2 border-primary rounded-lg shadow-lg p-6 relative">
              <div className="relative z-10">
                <h6 className="mb-1 font-semibold text-color">
                  Total Staked Ordinals
                </h6>
                <h2 className="text-white font-bold text-3xl">
                  {/* {myStakes
                    ? totalStalked
                      ? myStakes?.stalkedItems?.length + totalStalked
                      : myStakes?.stalkedItems?.length
                    : 0} */}
                  {myStakes?.stalkedItems?.length || 0}
                </h2>
              </div>
              <img
                className="absolute bottom-0 right-0 h-28 w-28 opacity-20"
                src="/assets/images/icon-1.png"
                alt="..."
              />
            </div>
          </div>
          <div className="flex-1">
            <div className="h-full bg-gradient-to-r from-body to-gray-800 border-2 border-primary rounded-lg shadow-lg p-6 relative">
              <div className="relative z-10">
                <h6 className="mb-1 font-semibold text-color">
                  Total Staked Runes
                </h6>
                <h2 className="text-white font-bold text-3xl">
                  {totalStalked || 0}
                </h2>
              </div>
              <img
                className="absolute bottom-0 right-0 h-28 w-28 opacity-20"
                src="/assets/images/icon-4.png"
                alt="..."
              />
            </div>
          </div>
        </figure>
        <figure className="mb-10">
          <h2 className="mb-6 text-3xl md:text-4xl font-bold text-white capitalize">
            Ordinals
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            {data?.map((collection: any, index: any) => (
              <div
                key={index}
                className="p-4 bg-gradient-to-r from-body to-gray-900 border-2 border-primary rounded-lg shadow-lg overflow-hidden relative"
              >
                <div className="aspect-square max-h-44 mx-auto rounded-lg bg-gray-400">
                  {/* <img
                    className="h-full w-full rounded-lg"
                    src={collection.render_url}
                    alt={collection.inscription_name}
                  /> */}
                  {/* <img
                    className="h-full w-full rounded-lg"
                    src={`https://ordinals.com/content/${collection?.inscription_id}`}
                    alt={collection.inscription_name}
                  /> */}
                  <iframe
                    title="cover image"
                    className="h-full w-full rounded-lg cover-image"
                    src={`https://ordinals.com/content/${collection?.inscription_id}`}
                  />
                </div>
                <h3 className="mt-4 text-color text-xl font-bold text-center">
                  {collection.inscription_name}
                </h3>
                {/* <h4 className="mt-1 text-base truncate text-center">
                  {collection.inscription_name}
                </h4> */}
                <h4 className="mt-1 text-base text-center absolute top-0 opacity-0 -z-10">
                  Price:{" "}
                  {priceData?.length !== 0 &&
                    priceData?.find(
                      (v: any) => v.collectionSymbol === collection?.slug
                    )?.fp}
                </h4>
                <div className="mt-6 flex gap-4">
                  <ButtonPrimary
                    type="button"
                    title={
                      myStakes &&
                      myStakes?.stalkedItems?.find(
                        (v: any) =>
                          v.inscription_name === collection?.inscription_name
                      )
                        ? "Unstake"
                        : "Stake"
                    }
                    onClick={() =>
                      handleStakeUnstakeCollection(
                        index,
                        collection,
                        myStakes?.stalkedItems?.find(
                          (v: any) =>
                            v.inscription_name === collection?.inscription_name
                        )
                      )
                    }
                  />
                </div>
                <div className="mt-4 rounded-lg bg-body p-3">
                  {myStakes?.stalkedItems?.find(
                    (v: any) =>
                      v.inscription_name === collection?.inscription_name
                  ) ? (
                    <div>
                      <Timer
                        startTime={convertTimestamp(
                          myStakes?.stalkedItems?.find(
                            (v: any) =>
                              v.inscription_name ===
                              collection?.inscription_name
                          )?.stackedAt
                        )}
                      />
                    </div>
                  ) : (
                    <div className="text-center font-medium">
                      <span>0d </span> <span>0h </span> <span>0m </span>{" "}
                      <span>0s</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </figure>
        <Ruins
          calculateSumOfValues={calculateSumOfValues}
          totalValue={totalValue}
          setTotalValue={setTotalValueRuin}
          setTotalStalked={setTotalStalked}
          totalStacked={totalStalked}
        />

        <figure className="mb-6">
          <Leaderboard />
        </figure>
      </div>
    </main>
  );
};

export default DashboardPage;
